const mainMenu = document.querySelector('#main-menu')
const menuToggleIcon = document.querySelector('#menu-toggle-icon')

function toggleMenu() {
    mainMenu.classList.toggle('!flex')
    document.body.classList.toggle('mobile-menu-open')

    menuToggleIcon.textContent === 'menu' ? (menuToggleIcon.textContent = 'close') : (menuToggleIcon.textContent = 'menu')
}

let dropdownBtn, dropdown
const submenu_classes = [
    '!block',
    '!opacity-100',
    '!pointer-events-auto',
    '!absolute',
    '!z-10',
    '!top-0',
    '!left-0',
    '!w-full',
    '!h-full',
]

document.addEventListener('click', function (e) {
    if (e.target.closest('.main-menu-toggle-btn')) {
        toggleMenu()
    }

    // if clicking outside of dropdown menu and dropdown menu is open then close it
    if (dropdown && e.target !== dropdown && !dropdown.contains(e.target)) {
        dropdownBtn.classList.remove('pointer-events-none')
        dropdown.classList.remove('!block')
    }

    if (e.target.classList.contains('dropdown-btn')) {
        dropdownBtn = e.target
        mainMenu.classList.remove('!flex')
        menuToggleIcon.name = 'menu'
        dropdown = e.target.closest('.dropdown-btn').nextElementSibling
        if (dropdown.classList.contains('!block')) {
            dropdown.classList.remove('!block')
        } else {
            dropdownBtn.classList.add('pointer-events-none')
            dropdown.classList.add('!block')
        }
    }

    if (e.target.classList.contains('sub-menu-toggle-button')) {
        if (window.innerWidth > 1024) {
            return
        }
        const parent = e.target.closest('.menu-item-has-children')
        const submenu = parent.querySelector('.sub-menu')
        if (submenu.classList.contains('!block')) {
            submenu.classList.remove(...submenu_classes)
        } else {
            submenu.classList.add(...submenu_classes)
        }
    }

})


